/** Finviz-style descriptive filter labels (English). */
export const stockScreenerDescriptiveEn = {
  market_cap: {
    mega: "Mega ($200B+)",
    large: "Large ($10B–$200B)",
    mid: "Mid ($2B–$10B)",
    small: "Small ($300M–$2B)",
    micro: "Micro ($50M–$300M)",
    nano: "Nano (< $50M)",
    o1b: "Over $1B",
    o500m: "Over $500M",
    o100m: "Over $100M",
    o50m: "Over $50M",
    o10m: "Over $10M",
    u1b: "Under $1B",
    u100m: "Under $100M",
    u50m: "Under $50M",
  },
  volume: {
    u50k: "Under 50K",
    u100k: "Under 100K",
    u500k: "Under 500K",
    u1m: "Under 1M",
    o50k: "Over 50K",
    o100k: "Over 100K",
    o500k: "Over 500K",
    o1m: "Over 1M",
    o2m: "Over 2M",
    o5m: "Over 5M",
    o10m: "Over 10M",
    o20m: "Over 20M",
  },
  avg_volume: {
    u50k: "Under 50K",
    u100k: "Under 100K",
    u500k: "Under 500K",
    u1m: "Under 1M",
    o50k: "Over 50K",
    o100k: "Over 100K",
    o500k: "Over 500K",
    o1m: "Over 1M",
    o2m: "Over 2M",
    o5m: "Over 5M",
    o10m: "Over 10M",
    o20m: "Over 20M",
  },
  shares_out: {
    u1m: "Under 1M",
    u5m: "Under 5M",
    u10m: "Under 10M",
    u20m: "Under 20M",
    o1m: "Over 1M",
    o5m: "Over 5M",
    o10m: "Over 10M",
    o20m: "Over 20M",
    o50m: "Over 50M",
    o100m: "Over 100M",
    o200m: "Over 200M",
    o500m: "Over 500M",
    o1b: "Over 1B",
  },
  float: {
    u1m: "Under 1M",
    u5m: "Under 5M",
    u10m: "Under 10M",
    u20m: "Under 20M",
    o1m: "Over 1M",
    o5m: "Over 5M",
    o10m: "Over 10M",
    o20m: "Over 20M",
    o50m: "Over 50M",
    o100m: "Over 100M",
    o200m: "Over 200M",
    o500m: "Over 500M",
    o1b: "Over 1B",
  },
  price: {
    u1: "Under $1",
    u2: "Under $2",
    u3: "Under $3",
    u5: "Under $5",
    u7: "Under $7",
    u10: "Under $10",
    u15: "Under $15",
    u20: "Under $20",
    u30: "Under $30",
    u40: "Under $40",
    u50: "Under $50",
    o1: "Over $1",
    o2: "Over $2",
    o3: "Over $3",
    o5: "Over $5",
    o7: "Over $7",
    o10: "Over $10",
    o15: "Over $15",
    o20: "Over $20",
    o30: "Over $30",
    o40: "Over $40",
    o50: "Over $50",
    o100: "Over $100",
    r1_5: "$1 – $5",
    r5_10: "$5 – $10",
    r10_20: "$10 – $20",
    r20_50: "$20 – $50",
    r50_100: "$50 – $100",
  },
} as const;
